/* Ayudate · Preguntas frecuentes */

import React, { useState } from "react";
import { CONTACTO } from "../datos/contacto";

const PREGUNTAS = [
  ["¿Cuánto cuesta una tutoría?",
   ["Depende del tutor: ", <b key="b1">cada uno pone su propia tarifa por hora</b>,
    ", en cualquier curso. El precio aparece en su perfil antes de que solicite nada, así que ",
    <b key="b2">no hay sorpresas ni hay que negociar con nadie</b>,
    ". Al comparar varios perfiles va a ver rangos distintos, igual que pasa con cualquier servicio."]],

  ["¿Cómo se paga?",
   [<b key="b1">Por SINPE Móvil, antes de la sesión</b>,
    ". Cuando envía la solicitud, un administrador confirma con el tutor que puede a la hora que "
    + "pidió y le escribe por correo con los datos para hacer el SINPE. Apenas se verifica la "
    + "transferencia, le llega otro correo confirmando la tutoría en firme, con el enlace de la "
    + "sala: el pago funciona además como confirmación oficial, así que ",
    <b key="b2">ese correo es su comprobante de que la sesión quedó apartada</b>, "."]],

  ["¿Por qué se paga antes y no después?",
   ["Porque es lo que le da certeza a las dos partes. El tutor aparta ese horario y no lo ofrece a "
    + "nadie más, y usted tiene la sesión asegurada. Si algo sale mal, la política de devolución le "
    + "cubre: con ", <b key="b1">más de 24 horas de anticipación se devuelve el 80%</b>,
    ", y ", <b key="b2">si el tutor no se presenta, el 100%</b>,
    ". Cancelando con ", <b key="b3">24 horas o menos se devuelve el 60%</b>,
    ", porque a esa altura el tutor ya bloqueó ese horario y no alcanza a ofrecerlo a nadie más: "
    + "de lo retenido, la mitad es para él y la mitad para la plataforma."]],

  ["¿Y si necesito cancelar?",
   [`Escríbanos por WhatsApp al ${CONTACTO.whatsappVisible} apenas sepa que no va a poder. No hay `
    + "formulario ni trámite: nos avisa y nosotros nos encargamos de avisarle al tutor y de "
    + "gestionar la devolución. Mientras antes nos escriba, mejor le va: con ",
    <b key="b1">más de 24 horas de anticipación se devuelve el 80%</b>,
    " y con ", <b key="b2">24 horas o menos, el 60%</b>, ". ",
    <b key="b3">Si el tutor no llega, se devuelve todo.</b>]],

  ["¿Qué hago si tengo un problema durante la clase en vivo?",
   [`Escríbanos por WhatsApp al ${CONTACTO.whatsappVisible}: `,
    <b key="b1">es el canal más rápido mientras la sesión sigue en curso</b>,
    ` (por ejemplo, si a alguna de las dos partes no le carga la sala o se le `
    + `corta la conexión). Para algo que puede esperar, también puede escribirnos a `
    + `${CONTACTO.correo}. La sala queda disponible unos minutos extra por si hay que reconectarse, `
    + "así que ", <b key="b2">no se pierde la sesión por un corte breve</b>, "."]],

  ["¿Dónde son las sesiones?",
   ["Todas las tutorías son ", <b key="b1">exclusivamente virtuales</b>,
    ". La sala se crea y la gestiona la administración de Ayudate: ",
    <b key="b2">el enlace de acceso le llega por correo</b>,
    " cuando se confirma la sesión, listo para conectarse a la hora acordada."]],

  ["¿Cómo entro a la sesión en vivo? ¿Qué navegador o dispositivo necesito?",
   ["Desde el correo de confirmación, o desde el botón \"Entrar a la sala\" si es tutor y entra "
    + "por su dashboard: el enlace abre una pestaña propia del navegador con la sala de reuniones "
    + "de Ayudate ya lista para conectarse, ",
    <b key="b1">sin instalar ninguna aplicación aparte</b>,
    ". Funciona en cualquier navegador actualizado (Chrome, Firefox, Safari o Edge), tanto en "
    + "computadora como en celular o tablet. Al entrar le va a pedir permiso para usar la cámara "
    + "y el micrófono: ", <b key="b2">hay que darle Permitir</b>,
    ", si no la otra persona no lo va a ver ni oír. ",
    <b key="b3">El enlace se activa 5 minutos antes de la hora acordada</b>,
    " y no antes, así que si entra muy temprano le va a avisar que la sala todavía no está lista."]],

  ["¿Qué pasa después de que termina la clase?",
   ["La sala se queda abierta ", <b key="b1">3 minutos más</b>,
    " después de la hora en que terminaba la sesión, como margen para despedirse con calma o "
    + "cerrar algún tema pendiente. Pasado ese margen, la tutoría se marca como completada sola y "
    + "le llega un correo a cada estudiante con un enlace para calificarla: cuánto le puso de 1 a "
    + "5, si repetiría con ese tutor y si fue puntual. Esa calificación es la que ",
    <b key="b2">se suma al perfil público del tutor</b>, ", así que ayuda mucho llenarla."]],

  ["¿Puedo pedir varias horas?",
   ["Sí. En la solicitud puede ", <b key="b1">marcar varias horas del mismo día</b>,
    ". Mientras más opciones dé, más fácil es cuadrar con el tutor. El total se calcula sobre "
    + "todas las horas que marque."]],

  ["¿Cómo sé que el tutor sabe del tema?",
   ["A cada tutor se le pide respaldo de lo que ofrece: en cursos de universidad, comprobante "
    + "de haber aprobado el curso con ", <b key="b1">nota igual o superior a 80</b>,
    "; en idiomas, ", <b key="b2">certificado del nivel que declara, de B2 a C2</b>,
    " según el Marco Común Europeo; en software, ",
    <b key="b4">certificado, diploma o constancia laboral del nivel de conocimiento que declara</b>,
    " en la herramienta; y en preparación para el examen de admisión, ",
    <b key="b5">el resultado oficial del examen que la persona misma hizo</b>,
    ". En materias de colegio no se pide comprobante. ",
    <b key="b3">Ningún perfil se publica sin que un administrador lo revise.</b>]],

  ["¿Puedo pedir que me hagan una tarea o un examen?",
   [<b key="b1">No, y es la única regla que aplicamos sin excepciones.</b>,
    " Ayudate existe para que aprenda el curso, no para que alguien lo haga por usted. Detectar "
    + "una solicitud de ese tipo implica la ", <b key="b2">salida inmediata de la plataforma</b>,
    ", tanto para el estudiante que la pide como para el tutor que la acepta."]],

  ["¿Cuánto tardan en responderme?",
   [<b key="b1">Menos de 24 horas.</b>,
    " Si tiene parcial esta semana, dígalo en la solicitud: priorizamos por urgencia."]],

  ["Quiero dar tutorías, ¿qué necesito?",
   ["Correo (va a ser nuestro medio oficial de comunicación con usted) y respaldo de lo que "
    + "ofrezca: ", <b key="b1">comprobante de 80 o más</b>,
    " en los cursos de universidad, certificado de su nivel B2 a C2 en los idiomas, respaldo de su "
    + "nivel de conocimiento en software, o su resultado del examen de admisión si prepara para "
    + "él. En materias de colegio no pedimos nota ni comprobante. Además, marcar "
    + "sus horarios en la grilla del registro. Usted pone su tarifa: ",
    <b key="b2">no hay tope ni precio impuesto</b>,
    ". Nosotros conseguimos los estudiantes, coordinamos la sesión y le liquidamos lo que le "
    + "corresponde."]],
];

export function Faq() {
  const [abierta, setAbierta] = useState(0);
  return (
    <div className="faq">
      {PREGUNTAS.map(([p, r], i) => {
        const on = abierta === i;
        return (
          <div className={`faqi ${on ? "on" : ""}`} key={i}>
            <h3>
              <button type="button" aria-expanded={on} aria-controls={`faq-${i}`}
                onClick={() => setAbierta(on ? -1 : i)}>
                <span>{p}</span>
                {/* Siempre el mismo signo: la hoja de estilos lo gira 45° al
                    abrir, así que la cruz se convierte en equis con un
                    movimiento y no cambiando de glifo de golpe. */}
                <i aria-hidden="true">+</i>
              </button>
            </h3>
            {/* La respuesta se queda montada aunque esté cerrada: es lo que
                permite animar también el cierre, y evita reconstruir el
                párrafo en cada toque. El alto lo anima la hoja de estilos
                interpolando grid-template-rows de 0fr a 1fr; cerrada, el
                visibility:hidden la saca del tabulador y del lector de
                pantalla, igual que si no estuviera. */}
            <div className="faqr" id={`faq-${i}`}><div><p>{r}</p></div></div>
          </div>
        );
      })}
    </div>
  );
}
